Ext.define('SA.view.BarChartToolbar', {
    extend: 'SA.view.Toolbar',

    initComponent() {
        var toolbar = this;

        this.items = [
            {
                xtype: 'pvt-auto-refreshing-attribute-dropdown',
                projectView: this.model
            },
            {
                xtype: 'pvt-text',
                text: 'sorted'
            },
            {
                xtype: 'combo-button',
                textTpl: '{label}',
                ui: 'underline',
                valueField: 'value',

                items: [
                    {label: 'Descending', value: 'desc'},
                    {label: 'Ascending', value: 'asc'}
                ],

                listeners: {
                    beforerender(cmp) {
                        cmp.refresh();

                        cmp.mon(toolbar.model, 'change:sortDirection', cmp.refresh, cmp);
                    }
                },

                refresh() {
                    this.setValue(toolbar.model.getSortDirection());
                },

                selectHandler(value) {
                    toolbar.model.setSortDirection(value);
                    toolbar.model.save();
                }
            },
            {
                xtype: 'pvt-fill'
            }, {
                xtype: 'view-actions-menu-button-2',

                menuItems: [
                    {
                        text: 'Edit View',
                        eventId: 'edit'
                    }, {
                        xtype: 'menuseparator'
                    }, {
                        text: 'Create Data Table',
                        eventId: 'createDataTable'
                    }, {
                        xtype: 'menuseparator'
                    }, {
                        text: 'Delete View',
                        eventId: 'delete'
                    }
                ]
            }, {
                xtype: 'pvt-export-button',
                margin: '0 10 0 0'
            }
        ];

        this.callParent();

        this.viewActionsMenuBtn = this.down('view-actions-menu-button-2');
    },

    initEvents() {
        this.callParent();

        this.viewActionsMenuBtn.on('click:menuItem:edit', () => this.fireEvent('click:viewActions:edit'));
        this.viewActionsMenuBtn.on('click:menuItem:createDataTable', () => this.fireEvent('click:viewActions:createDataTable'));
        this.viewActionsMenuBtn.on('click:menuItem:delete', () => this.fireEvent('click:viewActions:delete'));
    }
});
